import { render, staticRenderFns } from "./newCliente.vue?vue&type=template&id=2c3ede37&"
import script from "./newCliente.vue?vue&type=script&lang=js&"
export * from "./newCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports